import { frontend } from '../../../config';
import { Button } from '../../../components/Button/Button';
import { showNotification } from '../../../helper/showNotification';

type Props = {
  gameId: string | undefined;
};

const ButtonCopyGameLink = ({ gameId }: Props) => {
  const label = 'Link kopieren';
  const link = frontend.host + '/game/join?gameId=' + gameId;

  async function copyToClipboard() {
    if (!navigator.clipboard) {
      showNotification('Clipboard not available', 'warn');
      return;
    }
    await navigator.clipboard.writeText(link);
    showNotification('Kopiert', 'success');
  }

  if (!gameId) {
    showNotification('GameId not available', 'warn');
    return <></>;
  }

  return <Button onClick={copyToClipboard}>{label}</Button>;
};

export default ButtonCopyGameLink;
